import { memo } from 'react'

import type { AcfCardBlockProps } from '@typings'
import { CardLazyWrapper } from '@components/cards/RaCardLazyWrapper/RaCardLazyWrapper'
import { RaContainer } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'

import styles from './acf-card-block.module.scss'

export const AcfCardBlock = memo(({ cards }: AcfCardBlockProps) => {
  return (
    <RaContainer>
      <div className={styles['card-block-list']}>
        {cards?.length > 0 &&
          Loop(cards, (card, i) => (
            <CardLazyWrapper
              key={i}
              renderCard="region"
              {...{
                props: {
                  isEven: i % 2 === 0,
                  index: i,
                  card,
                },
              }}
            />
          ))}
      </div>
    </RaContainer>
  )
})

AcfCardBlock.displayName = 'AcfCardBlock'
